"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var folderId_1 = require("owa-service/lib/factory/folderId");
/* tslint:disable:restrict-import-path */
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
/* tslint:enable:restrict-import-path */
var getCalendarViewOperation_1 = require("owa-service/lib/operation/getCalendarViewOperation");
var getCalendarViewRequest_1 = require("owa-service/lib/factory/getCalendarViewRequest");
var targetFolderId_1 = require("owa-service/lib/factory/targetFolderId");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
function getCalendarViewService(rangeStart, rangeEnd) {
    // Example:
    // RangeStart: "2016-12-02T00:00:00.001",
    // RangeEnd: "2016-12-04T00:00:00.000"
    return getCalendarViewOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: getCalendarViewRequest_1.default({
            CalendarId: targetFolderId_1.default({
                BaseFolderId: folderId_1.default({
                    Id: folderNameToId_1.default('calendar'),
                }),
            }),
            RangeStart: rangeStart.toISOString(),
            RangeEnd: rangeEnd.toISOString(),
        }),
    }).then(function (response) {
        return response.Body.Items;
    });
}
exports.default = getCalendarViewService;
//# sourceMappingURL=getCalendarViewService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/services/getCalendarViewService.js
// module id = 4814
// module chunks = 48